import { render, staticRenderFns } from "./create-image.vue?vue&type=template&id=3c4e20b4&scoped=true"
import script from "./create-image.vue?vue&type=script&lang=js"
export * from "./create-image.vue?vue&type=script&lang=js"
import style0 from "./create-image.vue?vue&type=style&index=0&id=3c4e20b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4e20b4",
  null
  
)

export default component.exports